import { HpUserInteraction } from '@zg-rentals/ts-hotpads-api-client';
import { useQuery } from '@zg-rentals/react-query5';
import { type ContactHistoryListing, wasRecentlyContacted } from '@/src/lib/utils/recentlyContactedListing';
import { inquiryKeys } from './queryKeys';

export function useRecentlyContactedListing(
  listing: ContactHistoryListing | null | undefined,
  user: { loggedIn: boolean; email?: string },
): boolean {
  // Signed out, only the anonymous record counts (written by mock-inquiry submits, the
  // one flow that can submit without a session) — account-scoped records stay hidden
  // after logout, and the server-provided listing state belongs to no one.
  const email = user.loggedIn ? (user.email ?? '') : '';
  const { data: submittedAt } = useQuery<number | null>({
    queryKey: inquiryKeys.contacted(listing?.aliasEncoded ?? '', email),
    queryFn: () => null,
    enabled: false,
    staleTime: Infinity,
    meta: {
      tags: ['inquiry'],
      context: { api: 'hotpads-api', details: 'recently contacted listing cache' },
    },
  });
  if (submittedAt) {
    return wasRecentlyContacted({ userItemTypes: [HpUserInteraction.INQUIRY], userItemDates: { inquiry: { date: submittedAt } } });
  }
  if (!user.loggedIn) return false;
  return wasRecentlyContacted(listing);
}
